import { createSlice } from "@reduxjs/toolkit";
import { getTimeByTimeZoneOnMoment } from "../../../Common/utils";
import { AGING_TYPE, PURCHASE_ORDER_STATUS } from "../../../Common/constants";

const initialOrdersState = {
  entities: [],
  supplier: null,
  products: [],
  subTotal: 0,
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  Note: null,
  InternalNote: null,
  files: [],
  productCartStatus: null,
  status: null,
  reOrder: null,
  edit: false,
  Added: null,
  remove: null,
  completed: false,
  parked: false,
  orderId: null,
  is_parked: false,
  tab: "1",
  retrievedOrder: null,
  showResumeDialog: true,
  currentOrder: {},
  selectChannelOption: undefined,
  searchAllProduct: true,
  channelData: undefined,
  // warehouseOption: undefined,
  // warehouseData: undefined,
  deliveryDate: null,
  orderDate: null,
  auto_generate_no: true,
  no: null,
  supplier_invoice_aging: AGING_TYPE.DueImmediately.value,
  supplier_custom_status: false,
  supplier_invoice:"",
  invoice_custom_aging: "",
  scanItem: "",
  aiSuggestions: null, // For storing AI suggestions data
  aiUsed: false,
  message: {
    error: null,
    success: null,
    cartError: null,
    cartSuccess: null,
  },
};
export const callTypes = {
  list: "list",
  action: "action",
};

export const purchaseOrdersSlice = createSlice({
  name: "purchaseOrders",
  initialState: initialOrdersState,
  reducers: {
    catchError: (state, action) => {
      let error =
      action?.payload?.error?.response?.data?.errors || action?.payload?.error?.response?.data?.message||  action?.payload?.error?.message  || "Action Failed";
      if (error?.constructor?.name && error.constructor.name === "Object") {
        let temp = [];
        for (let [k, v] of Object.entries(error)) {
          temp.push(`${k}->${v}`);
        }
        error = temp;
      }
      state.message.error = error;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // findProducts
    productsFetched: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
      // state.products.map((product) => {
      //   state.entities = state.entities.filter((entity) => entity.id != product.id);
      // });
    },
    //remove product added to an order
    removeSelectedProduct: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { id } = action.payload;
      state.entities = state.entities.filter((product) => product.id != id);
    },
    // createOrder
    orderCreated: (state, action) => {
      const { message, entity, park } = action.payload;
      state.entities = [];
      // state.supplier = null;
      state.products = [];
      state.deliveryDate = null;
      state.orderDate = null;
      state.no = "";
      state.warehouseData = null;
      state.supplier_invoice = null;
      state.warehouseOption = null;
      state.subTotal = 0;
      state.listLoading = false;
      state.totalCount = 0;
      state.actionsLoading = false;
      state.error = null;
      state.message.error = null;
      state.message.success = message;
      state.currentOrder = {
        ...entity,
        purchase_order_details: entity.purchase_order_details.map((item) => {
          return {
            ...item,
            ordered_qty: item.ordered_qty,
            received_qty: item.received_qty,
            returned_qty: item.returned_qty,
            supply_price: item.supply_price,
            total_price: item.total_price,
            qty_in_piece: item.ordered_qty,
          };
        }),
      };
      state.completed = true;
    },
    orderParked: (state, action) => {
      const { message, entity, park } = action.payload;
      state.entities = [];
      // state.supplier = null;
      state.products = [];
      state.deliveryDate = null;
      state.orderDate = null;
      state.no = "";
      state.warehouseData = null;
      state.warehouseOption = null;
      state.subTotal = 0;
      state.listLoading = false;
      state.totalCount = 0;
      state.actionsLoading = false;
      state.error = null;
      state.message.error = null;
      state.message.success = message;
      state.currentOrder = entity;
      state.parked = true;
      state.supplier_invoice = null;
    },
    orderUpdated: (state, action) => {
      const { message, entity } = action.payload;
      state.actionsLoading = false;
      state.error = null;
      state.message.error = null;
      state.message.success = message;
      state.supplier_invoice = null;
      state.currentOrder = {
        ...entity,
        purchase_order_details: entity.purchase_order_details.map((item) => {
          return {
            ...item,
            ordered_qty: item.ordered_qty,
            received_qty: item.received_qty,
            returned_qty: item.returned_qty,
            supply_price: item.supply_price,
            total_price: item.total_price,
            qty_in_piece: item.ordered_qty,
          };
        }),
      };
      state.completed = true;
    },
    parkUpdated: (state, action) => {
      const { message, entity } = action.payload;
      state.actionsLoading = false;
      state.error = null;
      state.message.error = null;
      state.message.success = message;
      state.supplier_invoice = null;
      state.currentOrder = entity;
      state.parked = true;
    },
    // reOder
    setReOrder: (state, action) => {
      state.reOrder = action.payload;
    },
    // edit Order
    setEdit: (state, action) => {
      state.edit = action.payload;
    },
    // set show resume dialog
    setShowResume: (state, action) => {
      state.showResumeDialog = action.payload;
    },
    // addSupplier
    addSupplier: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.supplier = action.payload.supplier;
      state.entities = [];
    },
    addProduct: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.products.unshift(action.payload.product);
      state.message.success = "Product added to cart";
      state.added = true;
    },
    scanProduct: (state, action) => {
      state.actionsLoading = false;
      state.message.error = null;
      const { entities, queryParams } = action.payload;
      if (entities?.length) {
        state.scanItem = entities;
        // state.message.success = "Product Added Successfully"
      } else {
        state.scanItem = "notFound";
        // state.message.error = "Product Not Available or Out of Stock"
      }
    },

    saveProductList: (state, action) => {
      state.products = [...action.payload].map((el) => {
          const product = { ...el, subTotal: el.base_cost * el.quantity }
          delete product.manualPrice;
          return (product)})
    },

    setOrderTab: (state, action) => {
      state.tab = action.payload;
    },

    setSelectedOrder: (state, action) => {
      const { order, timezone, scan_id } = action.payload.order;
      const defaultSupplierInvoiceAging = order.supplier_invoice_aging ? order.supplier_invoice_aging : AGING_TYPE.DueImmediately.value;
      state.selectedOrder = {
        ...order,
        scan_id: scan_id,
        purchase_order_details: order.purchase_order_details.map((item) => {
          return {
            ...item,
            scanPosition: item.position,
            product: {
              ...item.product,
              base_cost: item.product.unit_prices[item.unit].base_cost,
              margin: item.product.unit_prices[item.unit].margin,
              margin_type: item.product.unit_prices[item.unit].margin_type,
              price: item.product.unit_prices[item.unit].price,
              tax_attributes: item.tax_attributes,
            },
            ordered_qty: item.ordered_qty,
            received_qty: item.received_qty,
            returned_qty: item.returned_qty,
            supply_price: item.supply_price,
            total_price: item.total_price,
          };
        }),
      };
      let warehouseOption = {};
      let orderPrice = 0;
      let products = order.purchase_order_details.map((d) => {
        let product = JSON.parse(JSON.stringify(d.product));
        product.purchase_order_detail_v2_id = d.id;
        product.bought_by_unit = d?.bought_by_unit;
        product.selected_unit_price = d?.selected_unit_price;
        product.totalPrice = d.total_price;
        product.orderQty = d.ordered_qty / d?.product?.unit_prices[d?.unit]?.lowest_unit_definition;
        product.unit = d.unit;
        product.lowest_unit_definition = d?.product?.unit_prices[d?.unit]?.lowest_unit_definition;
        product.quantity = d.ordered_qty; // d.ordered_qty - d.received_qty
        product.price = d?.product?.unit_prices[d?.unit]?.price;
        product.msrp_price = d?.product.msrp_price;
        product.newPrice = d.supply_price;
        product.base_cost = d.supply_price;
        product.oldCost = d.supply_price;
        product.rcv_qty = d.received_qty;
        product.rtn_qty = d?.returned_qty || 0;
        product.transferable_qty = Math.floor(product.transferable_qty / d?.product?.unit_prices[d?.unit]?.lowest_unit_definition);
        // product.ordered_qty = d.ordered_qty / d?.product?.unit_prices[d?.unit]?.lowest_unit_definition;
        // product.received_qty = d.received_qty / d?.product?.unit_prices[d?.unit]?.lowest_unit_definition;
        // product.returned_qty = d.returned_qty / d?.product?.unit_prices[d?.unit]?.lowest_unit_definition;
        product.tax_attributes = d.tax_attributes;
        product.order_supply_price = d.supply_price;
        orderPrice += d.total_price;
        product.subTotal = d.total_price;
        product.note = d.note;
        product.status = d?.status;
        product.position = d?.position;
        product.scanPosition = d?.position;

product.ai_explanation = d.ai_explanation || null;

        return product;
      });


      state.orderPrice = orderPrice;
      state.supplier = order.supplier;
      state.deliveryDate = getTimeByTimeZoneOnMoment(timezone, order.delivery_date);
      state.orderDate = getTimeByTimeZoneOnMoment(timezone, order.order_date);
      state.edit = order.id ? true : false;
      state.is_parked = (order.id && order.status === PURCHASE_ORDER_STATUS.PARKED.value) ? true : false;
      state.no = order.no;
      state.Note = order.note;
      state.InternalNote = order.internal_note;
      state.supplier_invoice_aging = order.supplier_custom_status ? AGING_TYPE.Custom.value : defaultSupplierInvoiceAging;
      state.invoice_custom_aging = order.supplier_custom_status ? order.supplier_invoice_aging : null;
      state.supplier_custom_status = order.supplier_custom_status;
      state.supplier_invoice = order.supplier_invoice;
      state.files = order.files;
      state.warehouseData = order.channel;
      warehouseOption.value = order.channel.id;
      warehouseOption.key = order.channel.id;
      warehouseOption.label = order.channel.name;
      state.warehouseOption = warehouseOption;

      const hasAIExplanation = products.some((p) => !!p.ai_explanation);
      state.aiUsed = hasAIExplanation;


      state.products = products;

      state.orderNo = order.no || null;
      state.orderId = order.id;
      state.receivingDate = getTimeByTimeZoneOnMoment(timezone, order.delivery_date);
      state.aiUsed = false;
    if (order.purchase_order_details?.length) {
      for (const item of order.purchase_order_details) {
        if (item?.ai_explanation || item?.product?.ai_explanation) {
          state.aiUsed = true;
          break;
        }
      }
    }

    },

    setOrderId: (state, action) => {
      state.orderId = action.payload.orderId;
    },
    updateQuantityByOne: (state, action) => {
      state.products = state.products.map((entity) => {
        const product = action.payload;

        if (!!product?.id && product.id === entity.id) {
          entity.quantity = Number(entity.quantity) + action.payload?.scanQty || 1;
          entity.orderQty = Number(entity.orderQty) + action.payload?.scanQty || 1;
          entity.subTotal = entity.quantity * entity.base_cost;
          entity.scanPosition = product.scanPosition;
        }
        return entity;
      });
    },
    // empty
    emptyProduct: (state, action) => {
      state.entities = [];
    },
    //update product quantity
    updateQuantity: (state, action) => {
      const { product, quantity } = action.payload;
      state.products = state.products.map((entity) => {
        if (!!product?.id && product.id === entity.id) {
          entity.quantity = quantity;
          entity.orderQty = quantity;
          entity.subTotal = entity.orderQty * entity.base_cost;
        }
        return entity;
      });
    },
    // update bought Unit
    updateBoughtUnit: (state, action) => {
      const { product, value } = action.payload;
      state.products = state.products.map((entity) => {
        if (!!product?.id && product.id === entity.id) {
          return { ...product, unit: value };
        }
        return entity;
      });
    },

    //change product price
    changePrice: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { product, price } = action.payload;
      state.products = state.products.map((entity) => {
        if (product.id === entity.id) {
          entity.base_cost = price;
          entity.subTotal = entity.quantity * entity.base_cost;
        }
        return entity;
      });
    },

    //remove product from cart
    removeProduct: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      const { product } = action.payload;
      state.products = state.products.filter((pros) => pros.id != product.id);
      state.entities.push(product);
      state.message.cartSuccess = "Product removed from cart";
      state.productCartStatus = null;
    },

    //deselect supplier selected for order
    removeSupplier: (state, action) => {
      state.actionsLoading = false;
      state.error = null;
      state.supplier = null;
    },
    emptySearchList: (state, action) => {
      state.entities = [];
      state.searchAllProduct = action.payload;
    },
setRetrievedOrder: (state, action) => {
  const { order } = action.payload;
  const defaultSupplierInvoiceAging = order.supplier_invoice_aging
    ? order.supplier_invoice_aging
    : AGING_TYPE.DueImmediately.value;

  state.retrievedOrder = order;
  state.selectChannelOption = order.channel
  state.supplier = order.supplier;
  state.deliveryDate = order.delivery_date;
  state.orderDate = order.order_date;
  state.no = order.no;
  state.Note = order.note;
  state.InternalNote = order.internal_note;
  state.supplier_invoice_aging = order.supplier_custom_status
    ? AGING_TYPE.Custom.value
    : defaultSupplierInvoiceAging;
  state.invoice_custom_aging = order.supplier_custom_status
    ? order.supplier_invoice_aging
    : null;
  state.supplier_custom_status = order.supplier_custom_status;
  state.files = order.files;
  state.supplier_invoice = order.supplier_invoice;
  state.orderNo = order.no || null;
  state.receivingDate = order.delivery_date;

  // Normalize products from order.cart
  state.products = (order.cart || []).map((p) => ({
    ...p,
    ai_explanation: p.ai_explanation || p.explanation || "",
    subTotal: (p.quantity || 0) * (p.base_cost || 0),
  }));

  // Set aiUsed = true if any product has ai_explanation
  state.aiUsed = state.products.some(
    (p) => !!p.ai_explanation || !!p.product?.ai_explanation
  );
}
,
    resetRetrievedOrder: (state, action) => {
      state.retrievedOrder = null;
    },
    setSearchedProducts: (state, action) => {
      state.products = action.payload;
    },
    searchAllProduct: (state, action) => {
      state.searchAllProduct = action.payload.value;
    },
    reviseProducts: (state, action) => {
      console.log("Slice Profducers", action);
      state.products = action.payload;
    },
    removeScanItem: (state) => {
      state.scanItem = null;
    },
    // updateOrder
    updateSubTotal: (state, action) => {
      state.error = null;
      state.subTotal = action.payload.total;
      // state.message.success = null;
    },

    changeCompleteStatus: (state, action) => {
      state.completed = action.payload.status;
    },
    //update message
    updateMessage: (state, action) => {
      const { type, message } = action.payload;
      switch (type) {
        case "error":
          state.message.error = message;
          break;
        case "success":
          state.message.success = message;
          break;
        case "cartSuccess":
          state.message.cartSuccess = message;
          break;
        case "cartError":
          state.message.cartError = message;
          break;
      }
    },

    resetStates: (state, action) => {
      state.retrievedOrder = null;
      state.orderId = null;
      state.entities = [];
      state.searchedSuppliers = null;
      state.suppliersTotalCount = null;
      state.supplier = null;
      state.products = [];
      state.discount = 0;
      state.coupon = "";
      state.Note = null;
      state.no = "";
      state.files = [];
      state.supplier_invoice_aging = AGING_TYPE.DueImmediately.value;
      state.supplier_invoice = null;
      state.supplier_custom_status = false;
      state.invoice_custom_aging = "";
      state.InternalNote = null;
      state.status = null;
      state.selectChannelOption = undefined;
      state.warehouseData = null;
      state.warehouseOption = null;
      state.deliveryDate = null;
      state.orderDate = null;
      state.subTotal = 0;
      state.totalCount = 0;
      state.error = null;
      state.message.error = null;
      state.supplierSearchValue = "";
      state.currentOrder = {};
      state.selectedOrder = {};
      state.reOrder = null;
      state.edit = false;
      state.showResumeDialog = true;
      state.aiSuggestions = null;
      state.aiUsed = false;
    },
    // empty cart
    emptyCart: (state, action) => {
      state.entities = [];
      state.supplier = null;
      state.products = [];
      state.warehouseData = null;
      state.warehouseOption = null;
      state.deliveryDate = null;
      state.orderDate = null;
      state.subTotal = 0;
      state.listLoading = false;
      state.totalCount = 0;
      state.orderError = null;
      state.actionsLoading = false;
      state.error = null;
      state.message.error = null;
      state.message.success = "Cart emptied!";
      state.aiSuggestions = null;
      state.aiUsed = false; // ← reset it when PO is reset
    },
    setChannel: (state, action) => {
      state.selectChannelOption = action.payload.selectedChannel;
      state.channelData = action.payload.channelDatas;
    },
    setChannelOption: (state, action) => {
      state.selectChannelOption = action.payload.selectedChannel;
    },
    setStatus: (state, action) => {
      state.status = action.payload.status;
    },
    setDeliveryDate: (state, action) => {
      state.deliveryDate = action.payload.deliveryDate;
    },
    setOrderDate: (state, action) => {
      state.orderDate = action.payload.orderDate;
    },
    setPoNumber: (state, action) => {
      state.no = action.payload.no;
    },
    setAIUsed: (state, action) => {
      state.aiUsed = action.payload.used;
    },

    setSupplierInvoiceRefNo:(state, action)=>{
      state.supplier_invoice = action.payload.supplier_invoice
    },
    setInvoiceAging: (state, action) => {
      state.supplier_invoice_aging = action.payload.aging;
    },
    setCustomeStatus: (state, action) => {
      state.supplier_custom_status = action.payload.status;
    },
    setAutoGenerate: (state, action) => {
      state.auto_generate_no = action.payload.autono;
    },
    setNote: (state, action) => {
      state.Note = action.payload.note;
    },
    setInternalNote: (state, action) => {
      state.InternalNote = action.payload.internalNote;
    },
    setSupplierProductNote: (state, action) => {
      const productIndex = state.products.findIndex(el => el.id == action.payload.id)
      state.products[productIndex].note = action.payload.productNote;
    },

    // New reducer for AI quantity prediction
    aiQuantitySuggestionsGenerated: (state, action) => {
      const { suggestedQuantities } = action.payload;
      state.actionsLoading = false;
      state.error = null;

      // Update product quantities based on AI prediction
      state.products = state.products.map(product => {
        const suggestion = suggestedQuantities.find(s => s.productId === product.id);
        if (suggestion) {
          return {
            ...product,
            quantity: suggestion.suggestedQuantity,
            orderQty: suggestion.suggestedQuantity,
            subTotal: suggestion.suggestedQuantity * product.base_cost
          };
        }
        return product;
      });

      // Calculate new subtotal
      let total = 0;
      for (let i = 0; i < state.products.length; i++) {
        let prod = state.products[i];
        total += prod.subTotal || 0;
      }
      state.subTotal = total;

      //state.message.success = "AI quantity prediction applied successfully!";
      state.aiSuggestions = suggestedQuantities;
    },


aiQuantitySuggestionsGeneratedPO: (state, action) => {
  const { supplier_id, period, period_type, category_ids, brand_ids } = action.payload;

  // Store the request parameters for reference
  state.aiRequestParams = { supplier_id, period, period_type, category_ids, brand_ids };

  // Set AI as used
  state.aiUsed = true;

  state.message.success = "AI is analyzing your data! Your Purchase Order will be ready in a few moments.";
},

  },
});
